import store from '@/store'

export default function permission() {
  const getPermissions = letter => {
    const perm = {
      can_reject: false,
      can_accept: false,
    }
    const letterPermissions = letter.letter_permissions ? letter.letter_permissions : {}
    return {
      ...perm,
      ...letterPermissions,
    }
  }
  const canReject = letter => getPermissions(letter).can_reject

  const canAccept = letter => getPermissions(letter).can_accept

  const canDownloadFile = letter => (letter.letter_status !== store.state.staticModule.letterStatusDraft)

  const canShowQuoteTable = letter => [store.state.staticModule.orgTypeOTM, store.state.staticModule.orgTypeITM].includes(letter.from_org.type_org_id)

  return {
    canReject,
    canAccept,
    canDownloadFile,
    canShowQuoteTable,
  }
}
